import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import { DateTime } from 'luxon'

const fetchInfo = async () => {
  const authStore = useAuthStore()
  const formStore = useFormStore()
  if (
    !authStore.isUserTypingCenter &&
    !authStore.isUserEstablishment &&
    !authStore.isUserServiceCenter
  ) {
    const res = await apiHelperService.get(`/api/individual/info`)
    formStore.draft.request.individualInfo = res
  } else if (authStore.isUserEstablishment) {
    const res = await apiHelperService.get(`/api/establishment/info`)
    formStore.draft.request.establishmentInfo = res
  }
}
const initInfo = async () => {
  const res = await fetchInfo()
}

export default async function () {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()

  let { administrativeRegionId } = router.currentRoute.value.query

  administrativeRegionId = authStore.isUserEstablishment
    ? authStore.user.administrativeRegionId
    : administrativeRegionId

  await initInfo()

  try {
    formStore.extraMap = {
      administrativeRegionId,

      hideOldEmiratesIdCardCopyOptions:
        globalStore.startedService.hideOldEmiratesIdCardCopyOptionsForUnifiedForm,

      enableMobileAppAuthorizationNewRequest:
        globalStore.startedService.enableMobileAppAuthorizationNewRequest
    }
  } catch (error) {
    console.error('use663Preload', error)
  }
}
